import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '..';
function formatDate(inputDate) {
    const date = new Date(inputDate); // Convert the input to a Date object
  
    // Define month names
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    // Extract date, month, and year
    const day = date.getUTCDate(); // Get the day of the month
    const month = months[date.getUTCMonth()]; // Get the month name
    const year = date.getUTCFullYear(); // Get the year
  
    // Return formatted string
    return `${day} ${month} ${year}`;
  }
const AppointmentTable = ({data}) => {
    const history = useNavigate();
    const handleDelete = async(id) =>{
        const apiCall = await fetch(`${API_URL}/api/job/delete-single/${id}`, {method:'DELETE'});
        if(apiCall.status ==200){
            window.location.reload()
        }
    }
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))
      
        const table = $('#dataTable').DataTable({
        data: data,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'client_name' },
            { data: 'phone' },
            { data: 'job_cost' },
            { data: 'assignedTo.name' },
            
            { data: 'createdAt',render : function(data,type,row) {
                return `<span>${formatDate(data)}</span>`
            } },
            { data: 'status' },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Job</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Job</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Job</a></li>
                </ul>
              </div>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/edit-job/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/view-job/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, []);
    return (
        <div className="card basic-data-table">
            <div className="card-header">
                <h5 className="card-title mb-0">List of Jobs</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    <label className="form-check-label">S.L</label>
                                </div>
                            </th>
                            
                            <th scope="col">Client Name</th>
                            <th scope="col">Client Phone</th>
                            <th scope="col">Amount</th>
                            <th scope="col" >Assigned To</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                   <tbody>

                   </tbody>
                </table>
            </div>
        </div>

    )
}

export default AppointmentTable